import { render, staticRenderFns } from "./PpMenu.vue?vue&type=template&id=15c06869"
import script from "./PpMenu.vue?vue&type=script&lang=js"
export * from "./PpMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports